import React, {
  useState,
} from 'react';
import { GoEyeClosed, GoEye } from 'react-icons/go';

import logoLogin from '../../assets/logo.png';
import background from '../../assets/login-background.png';
import { useAuth } from '../../hooks/auth';
import { authEmail } from '../../Firebase/authLogin';
import {
  Container,
  Img,
  Button,
  Button1,
  Input,
  InputModal,
} from './styles';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [eyeClosed, setEyeClosed] = useState(true);

  const { setSignedFunc } = useAuth();
  const handleSubmitLogin = async () => {
    console.log({
      email,
      password,
      s: 'ok',
    })
    const response = await authEmail(email, password);
    if (response?.user?.email === email) {
      localStorage.setItem('@off-let:signed', response.user.email);
      setSignedFunc();
    }
  };
  const handleVisiblePass = () => {
    setEyeClosed(!eyeClosed);
  };
  return (
    <Container img={background}>
      <Img src={logoLogin} />
      <InputModal>
        <label
        style={{
          color: 'rgb(94 98 120)',
          marginTop: '10px',
        }}
        >Usuário <small style={{color: '#c45'}}>*</small></label>
        <Input>
        <input
          style={{border: 'none', width: '100%', height: '100%', backgroundColor: 'transparent'}}
          name="email"
          placeholder="E-mail:"
          autoCapitalize="off"
          onChange={(event: any) => setEmail(event.target.value)}
          value={email}
        />
        </Input>
        <label
        style={{
          color: 'rgb(94 98 120)',
          marginTop: '10px',
        }}
        >Senha <small style={{color: '#c45'}}>*</small></label>
        <Input>
        {
            eyeClosed && (
              <>
              <input
                style={{border: 'none', width: '100%', height: '100%', backgroundColor: 'transparent'}}
                name="password"
                type="password"
                placeholder="Senha:"
                autoCapitalize="off"
                onChange={(event: any) => setPassword(event.target.value)}
                value={password}
              />
              <Button1 type="button" onClick={() => handleVisiblePass()}>
                  <GoEye size={17} color="#000" />
              </Button1>
              </>
            )
        }
        {
            !eyeClosed && (
            <>
            <input
            style={{border: 'none', width: '100%', height: '100%', backgroundColor: 'transparent'}}
              name="password"
              type="text"
              placeholder="Senha:"
              autoCapitalize="off"
              onChange={(event: any) => setPassword(event.target.value)}
              value={password}
            />
            <Button1 type="button" onClick={() => handleVisiblePass()}>
              <GoEyeClosed size={17} color="#000" />
            </Button1>
            </>
            )
        }
        </Input>
        <Button onClick={handleSubmitLogin}>Entrar</Button>

      </InputModal>
    </Container>

  );
};

export default Login;
